import { IndexView } from './views'
import { reducer } from './store'

export const routes = {
  chapters:         `/hoofdstukken`,
  chapter:          `/hoofdstukken/:chapter`,
  // quiz:             `/hoofdstukken/:chapter/oefentoets`,
  // 'quiz-summary':   `/hoofdstukken/:chapter/oefentoets/summary`,
  // 'quiz-question':  `/hoofdstukken/:chapter/oefentoets/:question`,
  lesson:           `/hoofdstukken/:chapter/:lesson`,
}

export const routeToInstall = {
  id: 'chapters',
  path: routes.chapters,
  component: IndexView,
}

export const storeToInstall = {
  chapters: reducer
}
